// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"cb","modalContent":"db","header":"eb","close":"fb"};